module.exports = __webpack_public_path__ + "img/42.576d1662.jpeg";